import { useState, useEffect } from 'react'
import * as serviceWorkerRegistration from '../serviceWorkerRegistration'
import Alert from '../components/Alert'

function ServiceWorkerLayout({ children }) {
  const [ waitingWorker, setWaitingWorker ] = useState()
  const [ showToast, setShowToast ] = useState(false)

  const onServiceWorkerUpdate = registration => {
    setWaitingWorker(registration && registration.waiting)
    setShowToast(true)
  }

  const updateServiceWorker = () => {
    waitingWorker && waitingWorker.postMessage({ type: 'SKIP_WAITING' })
    setShowToast(false)
    window.location.reload()
  }

  useEffect(() => {
    serviceWorkerRegistration.register({ onUpdate: onServiceWorkerUpdate })
  }, [])

  return <Alert
    onClose={() => setShowToast(false)}
    show={showToast}
    variant="success"
    styles='fixed -translate-x-1/2 -translate-y-1/2 bottom-8 left-1/2 z-[1000]'
  >
    <div className='flex items-center gap-3'>
      <h6>พบโปรแกรมเวอร์ชั่นใหม่ คลิ๊ก</h6>
      <button className='btn-success' onClick={() => updateServiceWorker()}>อัพเกรด</button>
    </div>
  </Alert>
}

export default ServiceWorkerLayout